import EventConfig from "./EventConfig";
import AuthService from "../auth/AuthService";
export default class EventService {
  /******* EVENTS **********/
  static getEvents(app) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointEvents;
        let response = await EventConfig.APIConnector.get(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static saveEvent(app, event, isCopyWithTickets, userId) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointSaveEvent;
        let response = await EventConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({
            event: event,
            isCopyWithTickets: isCopyWithTickets,
            userId: userId,
          }),
        });
        console.log("RESPONSE SAVE EVENT", response);
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static deleteEvent(app, eventId) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointDeleteEvent;
        let response = await EventConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({ id: eventId }),
        });
        console.log("RESPONSE DELETE EVENT", response, eventId);
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  /******** FIN EVENTS *********/
  /******** TICKET TYPES **********/
  static getTicketTypesByEvent(app, eventId) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointTicketTypes;
        let response = await EventConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({ id: eventId }),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static saveTicketType(app, eventId, ticketType, userId) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("ticketType", ticketType);
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointSaveTicketType;
        let response = await EventConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({
            eventId: eventId,
            ticketType: ticketType,
            userId: userId,
          }),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static deleteTicketType(app, eventId, ticketTypeId) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointDeleteTicketType;
        let response = await EventConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({
            eventId: eventId,
            ticketTypeId: ticketTypeId,
          }),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static getCategories(app) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointCategories;
        let response = await EventConfig.APIConnector.get(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }
  /******* FIN TICKET TYPES**********/
  /******** TICKETS **********/

  static getTicketsByEvent(app, filter, order, limit) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointTickets;
        let response = await EventConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({ filter: filter, order:order, limit:limit }),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static saveTickets(app, eventId, tickets, producerId, origin, userId) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointSaveTickets;
        let response = await EventConfig.APIConnectorLarge.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({ eventId: eventId, tickets: tickets }),
        });
        console.log("RESPONSE SAVE TICKET", response);
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static transferTicket(app, requestObj) {
    const { senderDocument, receiverDocument } = requestObj;
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = `${EventConfig.endpointTransfer}?senderDocument=${senderDocument}&receiverDocument=${receiverDocument}`;
        let response = await EventConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify(requestObj),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }
  static deleteTicket(app, eventId, ticketId, du, tktState) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointDeleteTicket;
        let response = await EventConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({
            eventId: eventId,
            ticketId: ticketId,
            du: du,
            tktState: tktState,
          }),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }
  /******* FIN TICKET **********/
  /******* STATISTICS **********/
  static getStatistics(app, eventId) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointStatistics;
        let response = await EventConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({ eventId: eventId }),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }
  //Deprecada
  // static getStatisticsRRPP(app, eventId) {
  //   return new Promise(async (resolve, reject) => {
  //     try{

  //       let token = await AuthService.getToken()
  //       let endpoint = EventConfig.endpointStatisticsRRPP
  //       let response = await EventConfig.APIConnector.post(endpoint, {
  //           headers: { Authorization: "Bearer " + token, App:app },
  //           body:JSON.stringify({eventId:eventId})
  //       });
  //       if(response.status==200){
  //         resolve(response.body)
  //       }else{
  //         reject(response)
  //       }
  //     }catch(e){
  //       reject(e)
  //     }
  //   });
  // }

  static getStatisticsDirectRRPP(app, eventId) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointStatisticsDirectRRPP;
        let response = await EventConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({ eventId: eventId }),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static getStatisticsReferencedRRPP(app, eventId) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointStatisticsReferencedRRPP;
        let response = await EventConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({ eventId: eventId }),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  static getStatisticsProducer(app, eventId) {
    return new Promise(async (resolve, reject) => {
      try {
        let token = await AuthService.getToken();
        let endpoint = EventConfig.endpointStatisticsProducer;
        let response = await EventConfig.APIConnector.post(endpoint, {
          headers: { Authorization: "Bearer " + token, App: app },
          body: JSON.stringify({ eventId: eventId }),
        });
        if (response.status == 200) {
          resolve(response.body);
        } else {
          reject(response);
        }
      } catch (e) {
        reject(e);
      }
    });
  }
  /******* FIN STATISTICS **********/
}



// WEBPACK FOOTER //
// ./src/provider/event/EventService.js